export const NAME = "projectsAdministration";
